(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["auto-gift-13592-13730"] && !Shopify.designMode) return;
  try {
    (() => {
    const notice = document.getElementById('AutoGiftNotice1359213730');
    if (!notice || notice.dataset.initialized === 'true') return;

    notice.dataset.initialized = 'true';

    const buyVariantId = Number(notice.dataset.buyVariantId);
    const giftVariantId = Number(notice.dataset.giftVariantId);
    const markerKey = '_auto_gift_for';
    const routeRoot = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    let syncing = false;
    let pending = false;
    let pendingOpen = false;
    let timer;
    let noticeTimer;

    const showNotice = (message) => {
      window.clearTimeout(noticeTimer);
      notice.textContent = message;
      notice.hidden = false;
      window.requestAnimationFrame(() => notice.classList.add('is-visible'));
      noticeTimer = window.setTimeout(() => {
        notice.classList.remove('is-visible');
        window.setTimeout(() => {
          notice.hidden = true;
        }, 180);
      }, 4000);
    };

    const request = async (path, body) => {
      const response = await fetch(routeRoot + path, {
        method: body ? 'POST' : 'GET',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: body ? JSON.stringify(body) : undefined
      });

      if (!response.ok) throw new Error('Cart request failed');
      return response.json();
    };

    const changeLine = (key, quantity) => request('cart/change.js', { id: key, quantity });

    const refreshCartUi = (open) => {
      if (document.body.classList.contains('cart-template')) {
        window.location.reload();
        return;
      }

      document.dispatchEvent(
        new CustomEvent('cart:refresh', {
          bubbles: true,
          detail: { open }
        })
      );
    };

    const run = async () => {
      if (syncing) return;

      syncing = true;
      const open = pendingOpen;
      pending = false;
      pendingOpen = false;

      try {
        const cart = await request('cart.js');
        const qualifyingQuantity = cart.items
          .filter((item) => Number(item.variant_id || item.id) === buyVariantId)
          .reduce((total, item) => total + item.quantity, 0);
        const giftLines = cart.items.filter((item) => {
          const properties = item.properties || {};
          return (
            Number(item.variant_id || item.id) === giftVariantId &&
            String(properties[markerKey]) === String(buyVariantId)
          );
        });
        const giftQuantity = giftLines.reduce((total, item) => total + item.quantity, 0);

        if (giftQuantity === qualifyingQuantity && giftLines.length <= 1) return;

        const primaryGiftLine = giftLines[0];

        if (!primaryGiftLine && qualifyingQuantity > 0) {
          await request('cart/add.js', {
            items: [
              {
                id: giftVariantId,
                quantity: qualifyingQuantity,
                properties: {
                  [markerKey]: String(buyVariantId)
                }
              }
            ]
          });
        } else if (primaryGiftLine && primaryGiftLine.quantity !== qualifyingQuantity) {
          await changeLine(primaryGiftLine.key, qualifyingQuantity);
        }

        for (const duplicateGiftLine of giftLines.slice(1)) {
          await changeLine(duplicateGiftLine.key, 0);
        }

        if (qualifyingQuantity === 0) {
          showNotice(notice.dataset.removedMessage);
        } else if (giftQuantity === 0) {
          showNotice(notice.dataset.addedMessage);
        } else {
          showNotice(notice.dataset.updatedMessage);
        }

        refreshCartUi(open);
      } catch (error) {
        showNotice(notice.dataset.errorMessage);
      } finally {
        syncing = false;

        if (pending) {
          const openAfterSync = pendingOpen;
          pending = false;
          pendingOpen = false;
          schedule(openAfterSync);
        }
      }
    };

    const schedule = (open = false) => {
      pending = true;
      pendingOpen = pendingOpen || open;
      if (syncing) return;
      window.clearTimeout(timer);
      timer = window.setTimeout(run, 80);
    };

    const offerTemplate = document.getElementById('AutoGiftOffer1359213730');
    const productForm = document.querySelector('form[is="product-form"]');
    const submitButton = productForm && productForm.querySelector('[type="submit"]');

    if (offerTemplate && submitButton) {
      submitButton.insertAdjacentElement('beforebegin', offerTemplate.content.firstElementChild.cloneNode(true));
    }

    document.addEventListener('product-ajax:added', () => schedule(true));
    document.addEventListener('cart:updated', () => schedule(false));
    window.addEventListener('pageshow', () => schedule(false));
    schedule(false);
  })();
  } catch(e) { console.error(e); }
})();

})();
